import { TopNav } from '@emburse/embark-header';
import renderEmbarkComplex from '../../util/renderEmbarkComplex';
import EmburseProfessionalLogoImage from '../../assets/images/emburse-professional-logo-300.svg';
// embark header web component
// local component state
let isMounted = false;
const mount = async (mountNodeId) => {
    if (isMounted) {
        return;
    }
    isMounted = true;
    const props = {
        homeUrl: window.location.href.includes('404') ? '/Home.aspx' : 'https://certify.com',
        logo: EmburseProfessionalLogoImage, // provides access to svg logo embedded in embark package
        businessUnit: 'Certify',
        mobileSize: 'sm'
    };
    renderEmbarkComplex(TopNav, props, mountNodeId);
};
export default mount;
